// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3HRn0","col":"CardReaderDesc_col__2CC8_","label":"CardReaderDesc_label__T5B4u"};